var bighouse = bighouse || {};

bighouse.searchActiveFilters = (function () {

    function setActiveFilters(activeArray){

        //console.log(activeArray);

        disableCheckboxGroup(activeArray.HouseFeatures, 'housefeatures');
        disableCheckboxGroup(activeArray.HouseStyles, 'housestyles');
        disableCheckboxGroup(activeArray.SuitableFor, 'suitablefor');
        
        //not needed because locations is an OR search not an AND search - BED only renders locations that have houses
        /*$(activeArray.Locations).each(function(){
            disableCheckboxSubsets();
        });*/


        //This doesn't really work from a UX pov.
        //bighouse.partyRange.activeFilterPartySize(activeArray.PartySizeMin, activeArray.PartySizeMax);
    }

    function disableCheckboxGroup(activeObj, name){
        var currentGroup = $('input[type="checkbox"][name="' + name + '"]').not('.js-filterAll');
        $(currentGroup).prop('disabled', false); //enable all checkboxes

        //get a full list of the checkboxes
        //remove all the active ones using the json response
        var disabledCheckboxes  = currentGroup.filter(function(currentGroup_el){
            return activeObj.filter(function(activeObj_el){
                return activeObj_el == currentGroup[currentGroup_el].value;
            }).length == 0
        
        }); 

        $(disabledCheckboxes).prop('disabled', true); //disabled all non active ones
    }



    return {
        setActiveFilters: setActiveFilters
    };
})();